import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateApp } from "../../hooks/useApps";
import { AppForm } from "./AppForm";
import { AppUserAccess } from "./AppUserAccess";

export function AppCreate() {
  const navigate = useNavigate();
  const createApp = useCreateApp();
  const [createdAppId, setCreatedAppId] = useState<string | null>(null);

  if (createdAppId) {
    return (
      <>
        <div className="page-header">
          <h2>Register a new app</h2>
        </div>
        <p className="muted" style={{ marginBottom: 16 }}>
          App created. Select which users should have access, then go to the app page.
        </p>
        <AppUserAccess appId={createdAppId} />
        <div style={{ marginTop: 16 }}>
          <button className="primary" onClick={() => navigate(`/apps/${createdAppId}`)}>
            Go to app
          </button>
          <button style={{ marginLeft: 8 }} onClick={() => navigate("/apps")}>
            All apps
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page-header">
        <h2>Register a new app</h2>
      </div>
      <AppForm
        submitLabel="Create"
        onSubmit={async (input) => {
          const app = await createApp.mutateAsync(input);
          setCreatedAppId(app.id);
        }}
        onCancel={() => navigate("/apps")}
      />
    </>
  );
}
